import { Component, ElementRef, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { LanguageService } from '@services/language/language.service';
import { LocalStorageService } from '@services/local-storage-service/local-storage.service';
import { ThemeService, EThemeName } from '@wind-log_library/fe-component-library';
import { filter, Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { loadHighchartsModules } from './modules/shared/config/chart-config/chart-config';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SidebarComponent, CommonModule, HeaderComponent, ScrollingModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, AfterViewInit {
  public theme$: Observable<string> | undefined;
  @ViewChild('sidebar', { read: ElementRef }) sidebarRef!: ElementRef;
  @ViewChild('mainWrapper') mainWrapper!: ElementRef<HTMLDivElement>;

  contentWidth = 0;

  constructor(
    private localStorageService: LocalStorageService,
    private themeService: ThemeService,
    private languageService: LanguageService,
    private router: Router,
  ) {
    this.languageService.initLanguage();
    loadHighchartsModules();
  }

  public ngOnInit() {
    this.theme$ = this.themeService.getTheme();
    this.themeListener();
  }
  ngAfterViewInit(): void {
    this.updateWidths();
    window.addEventListener('resize', () => this.updateWidths());
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.mainWrapper.nativeElement.scrollTop = 0;
    });
  }
  updateWidths() {
    const sidebarWidth = this.sidebarRef?.nativeElement.offsetWidth || 0;
    const totalWidth = window.innerWidth;
    this.contentWidth = totalWidth - sidebarWidth;
  }
  private themeListener(): void {
    const localStorageTheme = this.localStorageService.getThemeName(this.themeService.themeStoreName);
    if (!!localStorageTheme && localStorageTheme === EThemeName.DARK) {
      this.themeService.setTheme(EThemeName.DARK);
    } else {
      this.themeService.setTheme(EThemeName.LIGHT);
    }
  }
}
